// @flow
import invariant from 'invariant';
import { isNotEmpty } from 'utils/functional';
import { configString } from 'utils/config';

// HACK(arnav): It appears the flow type for actionDateFacet is not correct
// in the flow settings.
const getVolopsSearchIndex = (actionDateFacet?: ?Object, sort: ?string) => {
  const volopsIndexName = configString('algolia', 'volopsIndexName');
  invariant(isNotEmpty(volopsIndexName), 'volopsIndexName cannot be empty');
  return actionDateFacet && (actionDateFacet.starts || actionDateFacet.ends)
    ? `${volopsIndexName}-starts-asc`
    : sort === 'relevance'
    ? volopsIndexName
    : `${volopsIndexName}-published-desc`;
};

export default getVolopsSearchIndex;
